// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/chunks/" + ({1201: "datadogProfiler",1545: "vendors",8220: "lodash-vendor",9038: "datadogRecorder",}[chunkId] || chunkId) + "." + {1062: "ec995f45afec12b5",1201: "3a7f6e0436ee8a0d",1545: "34c80c4d3adc38b8",2603: "88e3f9fc633030ed",287: "e2472ecb1b546970",3657: "3a103d6bef1109b8",623: "44d3a935c08e0bf1",7594: "59987cc0afea55c9",8220: "487277ac6bccc5ea",8963: "f3381620195b1af6",9038: "14f83d7768a1c2c5",}[chunkId] + ".js"
}